import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { SITE } from "@/config/site";
import { getConsent, trackEvent } from "@/lib/analytics";

export const StickyMobileCta = () => {
  const [visible, setVisible] = useState(false);
  const [consentPending, setConsentPending] = useState(getConsent() === null);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.85);
    const onConsent = () => setConsentPending(getConsent() === null);
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("pm-consent-changed", onConsent);
    onScroll();
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("pm-consent-changed", onConsent);
    };
  }, []);

  const show = visible && !consentPending;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 80 }}
          animate={{ y: 0 }}
          exit={{ y: 80 }}
          transition={{ duration: 0.35, ease: "easeOut" }}
          className="fixed inset-x-0 bottom-0 z-40 md:hidden"
          data-testid="sticky-mobile-cta"
        >
          <a
            href={SITE.checkoutUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => {
              trackEvent("sticky_cta", { location: "sticky-mobile" });
              trackEvent("checkout_click", { location: "sticky-mobile" });
            }}
            className="flex items-center justify-center gap-2 border-t border-copper/30 bg-navy-deep/95 px-5 py-4 pb-[calc(1rem+env(safe-area-inset-bottom))] text-sm font-semibold uppercase tracking-wider text-copper backdrop-blur-xl"
          >
            E-book {SITE.introPrice} Kč
            <ArrowRight className="h-4 w-4" aria-hidden="true" />
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
